import { render, staticRenderFns } from "./input-price.vue?vue&type=template&id=c6bd27b4&scoped=true"
import script from "./input-price.vue?vue&type=script&lang=js"
export * from "./input-price.vue?vue&type=script&lang=js"
import style0 from "./input-price.vue?vue&type=style&index=0&id=c6bd27b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bd27b4",
  null
  
)

export default component.exports